import { type ComponentProps } from 'react';
import { PromoMessage } from '@hungryroot/app-public';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const PromoMessageIsland = islandRoot(
  (props: ComponentProps<typeof PromoMessage>) => {
    return <PromoMessage {...props} />;
  }
);
